__turbopack_context__.v({
  "chartCard": "UserOrdersOverTimeChart-module__y1E-Qq__chartCard",
  "chartWrapper": "UserOrdersOverTimeChart-module__y1E-Qq__chartWrapper",
  "errorText": "UserOrdersOverTimeChart-module__y1E-Qq__errorText",
  "loadingText": "UserOrdersOverTimeChart-module__y1E-Qq__loadingText",
  "noDataText": "UserOrdersOverTimeChart-module__y1E-Qq__noDataText",
});
